import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Award, CheckCircle2, XCircle } from "lucide-react";
import { toast } from "sonner";

export default function AdminPlacements() {
  const [items, setItems] = useState([]);

  const load = () => api.get(`${V1}/admin/placements/pending`).then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const verify = async (id) => {
    try {
      await api.post(`${V1}/admin/placements/${id}/verify`);
      toast.success("Onaylandı — okul profilinde gösterilecek");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Hata"); }
  };

  const reject = async (id) => {
    if (!window.confirm("Bu kayıt reddedilip silinsin mi?")) return;
    try {
      await api.post(`${V1}/admin/placements/${id}/reject`);
      toast.success("Reddedildi");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Hata"); }
  };

  return (
    <div className="space-y-6" data-testid="admin-placements-page">
      <div>
        <div className="overline text-accent">Doğrulama Kuyruğu</div>
        <h1 className="font-display text-3xl font-bold flex items-center gap-2"><Award className="h-7 w-7 text-primary" /> Yerleştirme Verisi Onayı</h1>
        <p className="text-muted-foreground text-sm mt-1">Okulların gönderdiği yerleştirme/burs istatistikleri, onaylanana kadar herkese açık gösterilmez.</p>
      </div>
      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs uppercase tracking-widest text-muted-foreground">
            <tr>
              <th className="text-left p-3">Okul</th><th className="text-left p-3">Yıl</th><th className="text-left p-3">Sınav</th>
              <th className="text-left p-3">Başvuran</th><th className="text-left p-3">Yerleşen</th><th className="text-left p-3">Burs Ort.</th>
              <th className="text-left p-3">Kaynak</th><th></th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={8} className="p-8 text-center text-muted-foreground">Onay bekleyen kayıt yok.</td></tr>}
            {items.map((p) => (
              <tr key={p.id} className="border-t border-border" data-testid={`admin-placement-row-${p.id}`}>
                <td className="p-3 font-medium">{p.school_name}</td>
                <td className="p-3 font-mono">{p.year}</td>
                <td className="p-3">{p.exam_type}</td>
                <td className="p-3">{p.total_applicants}</td>
                <td className="p-3 font-bold">{p.placed_count}</td>
                <td className="p-3">{p.scholarship_avg_pct != null ? `%${p.scholarship_avg_pct}` : "-"}</td>
                <td className="p-3 text-xs text-muted-foreground max-w-[160px] truncate">{p.source_note || "-"}</td>
                <td className="p-3 flex gap-1">
                  <Button size="sm" variant="outline" onClick={() => verify(p.id)} data-testid={`verify-placement-${p.id}`}>
                    <CheckCircle2 className="h-3.5 w-3.5 text-success" /> Onayla
                  </Button>
                  <Button size="sm" variant="ghost" onClick={() => reject(p.id)} data-testid={`reject-placement-${p.id}`}>
                    <XCircle className="h-3.5 w-3.5 text-destructive" />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
